import { useMutation, UseMutationResult } from 'react-query';
import { httpService } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';
import { TierResponse } from '../AccountLimitsType';

interface useRequestLimitsTierUpgradeProps {
  customerId: string;
  accountExternalId: string;
  nextTier: string;
}

export const useRequestLimitsTierUpgrade = (): UseMutationResult<
  TierResponse,
  Error,
  useRequestLimitsTierUpgradeProps
> =>
  useMutation<TierResponse, Error, useRequestLimitsTierUpgradeProps>(
    async ({ customerId, accountExternalId, nextTier }) => {
      const res = await httpService.post<TierResponse>(
        `${BASE_URL}/api/v1/user/${customerId}/account/${accountExternalId}/limits/tierInfo/requestUpgrade/?tier=${nextTier}`,
        null,
      );

      return res.data;
    },
  );
